/* eslint-disable react/self-closing-comp */
import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from './images';

const COLORS = {
  black: '#000000',
  white: '#FFFFFF',
  red: '#bc2433',
};

const Icon = ({ icon, color = 'white' }) => {
  if (!icon) return null;
  const iconColor = COLORS[color];
  const Component = Icons[icon.replace('-', '').toUpperCase()];
  return Component ? <Component color={iconColor} data-test={`${icon}-icon`} /> : null;
};

Icon.propTypes = {
  icon: PropTypes.string,
  color: PropTypes.string,
};

Icon.defaultProps = {
  color: 'white',
};

export default Icon;
